import { useUserStore } from '@/store/userStore'

export default ({ store, redirect }) => {
  const userStore = useUserStore()

  if (
    userStore.loggedIn &&
    !store.state.users.user.public_address &&
    store.state.users.user.type &&
    store.state.users.user.type !== 'superadmin'
  ) {
    return redirect('/auth/CompleteData')
  }
}
